<div class="container-fluid pb-3 pt-2">
  <h4 class="mb-2">{{headingText}}</h4>
  <div *ngIf="!loading; else loader">
    <form *ngIf="form" class="row" [formGroup]="form">
      <mat-form-field class="w-100">
        <buffered-input formControlName="nome" placeholder="Filtro"></buffered-input>
      </mat-form-field>
    </form>
    <resourceful-index #index [search]="search" [modelService]="tipoDannoService" [deleteFunction]="deleteFunction"
      [columnDefinitions]="columnDefinitions" [editFunction]="editFunction" [selectionMode]="selectionMode"
      [multipleSelection]="multipleSelection"
      (selectedModel)="closeDialogWithSelectedModel($event)" [relations]="relations">
    </resourceful-index>

    <button mat-raised-button color="primary" class="mt-4" (click)="add()">
      Aggiungi un tipo di danno<mat-icon>add</mat-icon>
    </button>
    <button *ngIf="multipleSelection" mat-raised-button color="primary" class="mt-4 ml-2" (click)="save()">
      Salva selezione
    </button>

  </div>
  <ng-template #loader>
    <mat-spinner></mat-spinner>
  </ng-template>
</div>
